import { render } from "./LogChanges.vue?vue&type=template&id=1f7ab6e8&scoped=true&ts=true"
import script from "./LogChanges.vue?vue&type=script&lang=ts"
export * from "./LogChanges.vue?vue&type=script&lang=ts"

import "./LogChanges.vue?vue&type=style&index=0&id=1f7ab6e8&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7ab6e8"]])

export default __exports__